if ( typeof QuickBuyToggle !== 'function' ) {

    class QuickBuyToggle extends HTMLElement {
  
      constructor() {        
        super();

        this.toggleButton = this.querySelector('button');   
        this.toggleButtonId = this.toggleButton.getAttribute('data-quick-buy-toggle');
        this.modal = document.getElementById(this.toggleButtonId);
        this.modalClose = this.modal.querySelector('.quick-buy-modal__close');

        this.toggleButton.addEventListener('click', this.openModal.bind(this));
        this.modalClose.addEventListener('click', this.closeModal.bind(this));

          document.querySelector('body').addEventListener('click', e=>{
            if ( e.target == document.querySelector('body') && this.modal.classList.contains('open') ) {
              this.closeModal();
            }
          });

      }

      openModal() {
        this.modal.style.display = 'block';
        requestAnimationFrame(()=>{
          this.modal.classList.add('open');
          document.querySelector('body').classList.toggle('quick-buy-modal-open');
        });
      }

      closeModal() {
        this.modal.classList.remove('open');
        this.modal.addEventListener('transitionend', function handler() {
          this.style.display = 'none';
          this.removeEventListener('transitionend', handler);
          document.querySelector('body').classList.remove('quick-buy-modal-open');
        });
      }      
    }

  
    if ( typeof customElements.get('quick-buy-toggle') == 'undefined' ) {
      customElements.define('quick-buy-toggle', QuickBuyToggle);
    }  
  }